import React from 'react';
import TextField from '@material-ui/core/TextField';

export default ({
  input,
  label,
  meta: { touched, error },
  name,
  ...custom
}) => (
  <TextField
    label={label}
    {...input}
    {...custom}
    FormHelperTextProps={{
      error: touched && !!error
    }}
    helperText={touched && error}
    fullWidth={true}
    className="auth--form-field"
  />
);



// WEBPACK FOOTER //
// ./src/components/Authentication/components/TextField.js